'use strict';

(function () {
    angular
        .module('tracking')
        .component('crewSuggestionsListComponent', {
            templateUrl: function($attrs){
                return $attrs.template;
            },
            controller: function (applicationConstants,TrackingHelper) {
                var vm = this;
                vm.isSwapEnable = false;
                vm.posStyle = compileStyle(vm.positionSettings);

                vm.onMouseEnter = function () {
                    vm.isSwapEnable = !!TrackingHelper.getSelectedCrew();
                };

                vm.onAddCrewClick = function (crew, flag) {
                    vm.onAddCrew({crew:crew, flag:flag});
                };

                vm.onSwapClick = function (crew) {
                    vm.onSwapCrew({crew : crew})
                };
                
                vm.onViewSchedule = function (crew) {
                    vm.onViewProfile({crew: crew});
                };
                
                function compileStyle(styleStr) {
                    var style = {top:0,bottom:0,minHeight:"80%"};
                    if(angular.isUndefined(styleStr) || styleStr!==""){
                        angular.forEach(styleStr.split(','), function (attr) {
                            var t = attr.split(':');
                            style[t[0].replace(/^\s+|\s+$/g, '')] = t[1];
                        });
                    }
                    return style;
                }
            },
            bindings: {
                crewList : '<',
                onAddCrew : '&',
                onSwapCrew : '&',
                onViewProfile: '&',
                positionSettings: '@'
            }
        });
})();
